import { Component, Output, EventEmitter } from '@angular/core';
import { Cut45AngleService } from '../services/cut45-angle.service';
import { CutCornerNotchService } from '../services/cut-corner-notch.service';
import { MoveCornerService } from '../Component(2D and 3D)/2D/move-corner.service';
import { RemovePointService } from '../services/remove-point.service';
import { CutUshapeService } from '../services/cut-ushape.service';
import { DragFloorEdge } from '../services/drag-floor-edge.service';
import { ComponentBase } from '../component-base';
declare let THREE: any;
import { SceneUtilsService } from '../services/scene-utils.service';
import { BuildFloorService } from '../services/build-floor.service';
import { StageService } from '../services/stage.service';
import { DataForDisplayingMenuItemsService } from '../services/data-for-displaying-menu-items.service';

@Component({
  selector: 'app-edit-shape',
  templateUrl: './edit-shape.component.html',
  styleUrls: ['./edit-shape.component.scss']
})

export class EditShapeComponent extends ComponentBase {

  private raycaster: any = new THREE.Raycaster();

  @Output() step1Editer = new EventEmitter();

  isShape45: boolean = false;
  isShapeCorner: boolean = false;
  isShapeU: boolean = false;
  isMovePoint: boolean = false;
  isRemove: boolean = false;
  selectedShapeType = '';

  constructor(
    private cut45angle: Cut45AngleService,
    private cutCornerNotch: CutCornerNotchService,
    private moveCorner: MoveCornerService,
    private removePoint: RemovePointService,
    private cutUShape: CutUshapeService,
    private moveWall: DragFloorEdge,
    private sceneUtils: SceneUtilsService,
    private buildFloorService: BuildFloorService,
    private stage: StageService,
    private dataForDisplayingMenuItemsService : DataForDisplayingMenuItemsService
  ) {
    super();
    this.dataForDisplayingMenuItemsService.changeSelectedMenuItem.subscribe(value => {
      this.selectedShapeType = value;
    })
  }

  goBack(value) {
    this.step1Editer.emit({ name: value });
    this.dataForDisplayingMenuItemsService.changeSelectedMenuItem.next('');
  }

  mouseDown(e) {
    var p = this.sceneUtils.getRay(e.offsetX, e.offsetY);
    this.raycaster.ray.origin.copy(p.ray.origin);
    this.raycaster.ray.direction.copy(p.ray.direction);

    var floor = this.stage.getCompoundFloor();
    let sprites = this.stage.getSprites();
    var intersection = this.raycaster.intersectObjects([...floor.children, ...sprites]);
    if (!intersection.length) {
      this.dataForDisplayingMenuItemsService.changeSelectedMenuItem.next('');
      this.remove();
    }

  }

  cut45() {
    this.clear();
    if (!this.cut45angle.isEnabled()) {
      this.remove();
      this.cut45angle.enable();
      this.cut45angle.drawSprites();
      this.isShape45 = true;
      this.dataForDisplayingMenuItemsService.changeSelectedMenuItem.next('cut45')
    } else {
      this.dataForDisplayingMenuItemsService.changeSelectedMenuItem.next('');
      this.cut45angle.removeSprites();
      this.cut45angle.disable();
    }
  }

  cutU() {
    this.clear();
    if (!this.cutUShape.isEnabled()) {
      this.remove();
      this.cutUShape.enable();
      this.cutUShape.drawSprites();
      this.isShapeU = true;
      this.dataForDisplayingMenuItemsService.changeSelectedMenuItem.next('cutU');
    } else {
      this.dataForDisplayingMenuItemsService.changeSelectedMenuItem.next('');
      this.cutUShape.removeSprites();
      this.cutUShape.disable();
    }
  }

  cutCorner() {
    this.clear();
    if (!this.cutCornerNotch.isEnabled()) {
      this.remove();
      // this.orbit.disable();
      this.cutCornerNotch.enable();
      this.cutCornerNotch.drawSprites();
      this.isShapeCorner = true;
      this.dataForDisplayingMenuItemsService.changeSelectedMenuItem.next('cutCorner');
    } else {
      this.dataForDisplayingMenuItemsService.changeSelectedMenuItem.next('');
      this.cutCornerNotch.removeSprites();
      this.cutCornerNotch.disable();
    }
  }

  removeP() {
    this.clear();
    if (!this.removePoint.isEnabled()) {
      this.remove();
      this.removePoint.enable();
      this.removePoint.drawSprites();
      this.isRemove = true;
      this.dataForDisplayingMenuItemsService.changeSelectedMenuItem.next('removeP');
    } else {
      this.dataForDisplayingMenuItemsService.changeSelectedMenuItem.next('');
      this.removePoint.removeSprites();
      this.removePoint.disable();

    }
  }

  movePoint() {
    this.clear();
    if (!this.moveCorner.isEnabled()) {
      this.remove();
      this.moveCorner.enable();
      this.moveCorner.drawSprites();
      // if (this.camera.isIn3D()) {
      //  this.orbit.disable(); 
      // }
      // this.moveCamera.disable();
      this.dataForDisplayingMenuItemsService.changeSelectedMenuItem.next('movePoint');
    } else {
      this.dataForDisplayingMenuItemsService.changeSelectedMenuItem.next('');
      // if (this.camera.isIn3D()) {
      //   this.orbit.enable(); 
      //  }
      this.moveCorner.removeSprites();
      this.moveCorner.disable();
      // this.moveCamera.enable();
    }
  }

  clear() {
    this.isShape45 = false;
    this.isShapeCorner = false;
    this.isShapeU = false;
    this.isMovePoint = false;
    this.isRemove = false;
  }

  remove() {
    this.cut45angle.removeSprites();
    this.cut45angle.disable();
    this.cutCornerNotch.removeSprites();
    this.cutCornerNotch.disable();
    this.moveCorner.removeSprites();
    this.moveCorner.disable();
    this.removePoint.removeSprites();
    this.removePoint.disable();
    this.cutUShape.removeSprites();
    this.cutUShape.disable();
    this.moveWall.removeSprites();

    // this.moveCamera.enable();
    // this.orbit.enable();
  }

}



// WEBPACK FOOTER //
// ./src/app/edit-shape/edit-shape.component.ts